import React, { useMemo, useCallback } from 'react';
import Accordion from 'components/Accordion';
import RadioButton from 'components/DesignSystem/RadioButton';
import TitleSemiBold from 'components/Typography/TitleSemiBold';
import usePeriodType from 'hooks/Meteorology/Fields/ModelPerformance/usePeriodType';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';

export default function PeriodType() {
  const { periodType, setPeriodType } = usePeriodType();
  const closeAccordion = useMemo(() => buildAccordionClickFunction('period-type-accordion'), []);

  const setPeriodTypeAndClose = useCallback((value: string) => {
    setPeriodType(value);
    closeAccordion();
  }, [setPeriodType, closeAccordion]);

  return (
    <Accordion.Item eventKey="period-type" id="period-type-accordion">
      <Accordion.Header>
        <TitleSemiBold>Período</TitleSemiBold>
      </Accordion.Header>
      <Accordion.Body>
        <RadioButton
          id="period-type-preset"
          label="Pré-definido"
          checked={periodType === 'preset'}
          onChange={() => setPeriodTypeAndClose('preset')}
          className="my-2"
        />
        <RadioButton
          id="period-type-free"
          label="Livre"
          checked={periodType === 'free'}
          onChange={() => setPeriodTypeAndClose('free')}
          className="my-2"
        />
      </Accordion.Body>
    </Accordion.Item>
  );
}
